// src/components/ProjectCard.jsx
import React from "react";
import { motion } from "framer-motion";

const cardVariant = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      type: "spring",
      bounce: 0.3,
    },
  },
};

export default function ProjectCard({ project, onClick }) {
  function getImageUrl(img) {
    if (!img) return null;
    // Use absolute URL for production, but strip '/api' for image URLs
    const API_BASE = process.env.REACT_APP_API_BASE || "https://palegreen-snake-884644.hostingersite.com/backend";
    const BASE = API_BASE.replace(/\/api$/, "");
    if (img.startsWith("/uploads")) {
      return  img;
    }
    return img;
  }

  return (
    <motion.div
      className="cursor-pointer"
      variants={cardVariant}
      initial="hidden"
      animate="show"
      whileHover={{ y: -8, scale: 1.02 }}
      onClick={onClick}
    >
      <div className="bg-black rounded-2xl shadow-md hover:shadow-xl overflow-hidden transition-all duration-300 h-full flex flex-col">
        <div
          className="h-40 w-full bg-center bg-cover flex items-center justify-center"
          style={{
            backgroundImage: project.image
              ? `url(${getImageUrl(project.image)})`
              : "linear-gradient(to bottom right, #e5e7eb, #d1d5db)",
          }}
        >
          {!project.image && (
            <span className="text-3xl font-bold text-slate-400">
              {project.name?.charAt(0) || "P"}
            </span>
          )}
        </div>
        <div className="p-5 flex-1 flex flex-col items-center justify-center">
          <h3 className="font-semibold text-lg mb-1 line-clamp-2 text-center text-white">
            {project.name}
          </h3>
        </div>
      </div>
    </motion.div>
  );
}
